import { createSlice } from "@reduxjs/toolkit"

const adsSlice = createSlice({
  name: "ads",
  initialState: {
    ads: null,
    getAdsWithCreativesLoading: false,
    updateCreativeGroupsLoading: false,
    updateLandingPageUrlLoading: false,
    searchLandingPagesLoading: false,
    searchLandingPagesResults: [],
    updateAdLoading: false,
  },
  reducers: {
    getAdsWithCreativesLoading: (state) => {
      state.getAdsWithCreativesLoading = true
    },
    getAdsWithCreativesSuccess: (state, action) => {
      state.ads = action.payload
      state.getAdsWithCreativesLoading = false
    },
    getAdsWithCreativesFailure: (state) => {
      state.getAdsWithCreativesLoading = false
    },
    updateCreativeGroupsLoading: (state) => {
      state.updateCreativeGroupsLoading = true
    },
    updateCreativeGroupsSuccess: (state) => {
      state.updateCreativeGroupsLoading = false
    },
    updateCreativeGroupsFailure: (state) => {
      state.updateCreativeGroupsLoading = false
    },

    searchLandingPagesLoading: (state) => {
      state.searchLandingPagesLoading = true
    },
    searchLandingPagesSuccess: (state, action) => {
      state.searchLandingPagesResults = action.payload
      state.searchLandingPagesLoading = false
    },
    searchLandingPagesFailure: (state) => {
      state.searchLandingPagesLoading = false
      state.searchLandingPagesResults = []
    },
    clearSearchResults: (state) => {
      state.searchLandingPagesResults = []
    },
    updateAdLoading: (state) => {
      state.updateAdLoading = true
    },
      updateAdSuccess: (state) => {
      state.updateAdLoading = false
    },
    updateAdFailure: (state) => {
      state.updateAdLoading = false
    },
  },
})

export const {
  getAdsWithCreativesLoading,
  getAdsWithCreativesSuccess,
  getAdsWithCreativesFailure,
  updateCreativeGroupsLoading,
  updateCreativeGroupsSuccess,
  updateCreativeGroupsFailure,
  searchLandingPagesLoading,
  searchLandingPagesSuccess,
  searchLandingPagesFailure,
  clearSearchResults,
  updateAdLoading,
  updateAdSuccess,
  updateAdFailure,
} = adsSlice.actions

export default adsSlice.reducer
